var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"circle-button d-flex justify-content-center align-items-center",style:(_vm.circleStyle),on:{"click":_vm.triggerClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }